import { create } from 'zustand'

export type ToastTone = 'success' | 'error' | 'info'

export type ToastContent = {
  title: string
  description?: string
}

export type ToastItem = {
  id: number
  tone: ToastTone
  title: string
  description?: string
}

type ToastState = {
  toasts: ToastItem[]
  push: (tone: ToastTone, content: ToastContent | string) => void
  dismiss: (id: number) => void
}

let counter = 0

const defaultTitles: Record<ToastTone, string> = {
  success: 'Sucesso',
  error: 'Erro',
  info: 'Informação',
}

function normalizeContent(tone: ToastTone, content: ToastContent | string): ToastContent {
  if (typeof content === 'string') {
    return { title: defaultTitles[tone], description: content }
  }
  return content
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (tone, content) => {
    counter += 1
    const id = counter
    const normalized = normalizeContent(tone, content)
    set((state) => ({ toasts: [...state.toasts, { id, tone, ...normalized }] }))
    window.setTimeout(() => {
      set((state) => ({ toasts: state.toasts.filter((item) => item.id !== id) }))
    }, 4000)
  },
  dismiss: (id) => {
    set((state) => ({ toasts: state.toasts.filter((item) => item.id !== id) }))
  },
}))

export const toast = {
  success: (content: ToastContent | string) => {
    useToastStore.getState().push('success', content)
  },
  error: (content: ToastContent | string) => {
    useToastStore.getState().push('error', content)
  },
  info: (content: ToastContent | string) => {
    useToastStore.getState().push('info', content)
  },
}
